module.exports = __webpack_public_path__ + "static/media/month-3.47efc2d4.png";